<!-- Issue 61 - Get installations list -->
<div class="card-header" id="installOwnerHeader">
    <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
        data-target="#installOwnerCollapse" aria-expanded="true" aria-controls="installOwnerCollapse">
        Liste des installations et de leur propriétaire
    </button>
</div>

<div id="installOwnerCollapse" class="panel-collapse collapse" aria-labelledby="installOwnerHeader"
    data-parent="#accordionExtraction">
    <div class="card-body row">
        <h4>Liste des installations et de leur propriétaire</h4>
        <br><br>


        <div class="wrapper shadowed">

            <br />

            <h4>Résultats</h4>
            <app-gmao-spinner *ngIf="!listinstallowner"></app-gmao-spinner>
            <ng-container *ngIf="!isLoading && listinstallowner">
                <app-export-button [data]="listinstallowner"></app-export-button>

                <br />
                <mat-table [dataSource]="listinstallowner">
                    <ng-container matColumnDef="numeroSerie">
                        <mat-header-cell *matHeaderCellDef> Numéro de série </mat-header-cell>
                        <mat-cell *matCellDef="let rowInstall"> {{rowInstall.NUMERO_SERIE}} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="dateInstallation">
                        <mat-header-cell *matHeaderCellDef> Date d'installation </mat-header-cell>
                        <mat-cell *matCellDef="let rowInstall"> {{getNiceDate(rowInstall.DATE_INSTALLATION)}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="nomInstallation">
                        <mat-header-cell *matHeaderCellDef> Nom de l'installation </mat-header-cell>
                        <mat-cell *matCellDef="let rowInstall"> {{rowInstall.NOM_INSTALLATION}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="raisonSociale">
                        <mat-header-cell *matHeaderCellDef> Raison sociale </mat-header-cell>
                        <mat-cell *matCellDef="let rowInstall"> {{rowInstall.RAISON_SOCIALE}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="codeEbp">
                        <mat-header-cell *matHeaderCellDef> Code EBP </mat-header-cell>
                        <mat-cell *matCellDef="let rowInstall"> {{rowInstall.CODE_EBP}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="prenom">
                        <mat-header-cell *matHeaderCellDef> Prénom </mat-header-cell>
                        <mat-cell *matCellDef="let rowInstall"> {{rowInstall.PRENOM}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="nom">
                        <mat-header-cell *matHeaderCellDef> Nom </mat-header-cell>
                        <mat-cell *matCellDef="let rowInstall"> {{rowInstall.NOM}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="adresse">
                        <mat-header-cell *matHeaderCellDef> Adresse </mat-header-cell>
                        <mat-cell *matCellDef="let rowInstall"> {{rowInstall.ADRESSE}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="complementAdresse">
                        <mat-header-cell *matHeaderCellDef> Complément d'adresse </mat-header-cell>
                        <mat-cell *matCellDef="let rowInstall"> {{rowInstall.COMPLEMENT_ADRESSE}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="codePostal">
                        <mat-header-cell *matHeaderCellDef> Code postal </mat-header-cell>
                        <mat-cell *matCellDef="let rowInstall"> {{rowInstall.CODE_POSTAL}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="ville">
                        <mat-header-cell *matHeaderCellDef> Ville </mat-header-cell>
                        <mat-cell *matCellDef="let rowInstall"> {{rowInstall.VILLE}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="pays">
                        <mat-header-cell *matHeaderCellDef> Pays </mat-header-cell>
                        <mat-cell *matCellDef="let rowInstall"> {{rowInstall.PAYS}}</mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumnInstallOwner"></mat-header-row>
                    <mat-row
                        *matRowDef="let row; columns: ['numeroSerie', 'dateInstallation','nomInstallation','raisonSociale','codeEbp','prenom','nom','adresse','complementAdresse','codePostal','ville','pays'] ;"
                        (click)="clickRow(row)">
                    </mat-row>
                </mat-table>

            </ng-container>

        </div>
        <br />
    </div>
</div>